import React from 'react';
import { useTranslation } from 'react-i18next';

import type IImpactedProductsSection from './interfaces/IImpactedProductsSection';

import styles from './sass/ImpactedProductsSection.module.scss';

function ImpactedProductsSection({
  impactedProductsCount,
  productsPercentage,
  totalProductsCount,
}: IImpactedProductsSection): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section className={styles.tile}>
      <h4 className={styles.tileTitle}>{t('valueChainMap.resultCardImpactedProducts')}</h4>
      <div className={styles.tileValue}>
        {productsPercentage}
        %
      </div>
      <p className={styles.descMeta}>
        <span className={styles.metaAccent}>{impactedProductsCount}</span>
        {`/${totalProductsCount} ${t('valueChainMap.resultCardProducts')}`}
      </p>
    </section>
  );
}

export default ImpactedProductsSection;
